import type { HTMLAttributes, ReactNode } from 'react';
export function Section({
  surface = 'plain',
  narrow = false,
  flow = false,
  className = '',
  ...props
}: HTMLAttributes<HTMLElement> & {
  surface?: 'plain' | 'card' | 'subtle';
  narrow?: boolean;
  flow?: boolean;
}): JSX.Element {
  return (
    <section
      {...props}
      className={`ui-section ui-section--${surface}${narrow ? ' ui-section--narrow' : ''}${flow ? ' ui-stack' : ''} ${className}`.trim()}
    />
  );
}
export function Title({
  level = 1,
  className = '',
  ...props
}: HTMLAttributes<HTMLHeadingElement> & { level?: 1 | 2 | 3 | 4 }): JSX.Element {
  const Tag: 'h1' | 'h2' | 'h3' | 'h4' = `h${level}`;
  return <Tag {...props} className={`ui-title ui-title--${level} ${className}`.trim()} />;
}
export function PageHeading({
  title,
  description,
  eyebrow,
  action,
}: {
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  action?: ReactNode;
}): JSX.Element {
  return (
    <header className="ui-page-heading">
      <div>
        {eyebrow && <p className="ui-eyebrow">{eyebrow}</p>}
        <Title>{title}</Title>
        {description && <p className="ui-page-description">{description}</p>}
      </div>
      {action && <div className="ui-page-heading__action">{action}</div>}
    </header>
  );
}
export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}): JSX.Element {
  return (
    <div className="ui-empty">
      {icon && (
        <span className="ui-empty__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <Title level={3}>{title}</Title>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}
